export default "__VITE_ASSET__18b72164__"